<template>
  <transition name="zm-message-fade">
    <div
      :class="[
        'zm-message',
        type && !iconClass ? `zm-message--${ type }` : '',
        center ? 'is-center' : '',
        showClose ? 'is-closable' : '',
        customClass
      ]"
      :style="{top: verticalOffset + 'px'}"
      v-show="visible"
      @mouseenter="clearTimer"
      @mouseleave="startTimer"
    >
      <i :class="iconClass" v-if="iconClass"></i>
      <i :class="typeClass" v-else></i>
      <slot>
        <p v-if="!dangerouslyUseHTMLString" class="zm-message__content">
          {{ message }}
        </p>
        <!-- eslint-disable vue/no-v-html -->
        <p v-else v-html="message" class="zm-message__content"></p>
        <!-- eslint-enable -->
      </slot>
      <zm-button
        v-if="showClose"
        ghost
        type="icon"
        size="mini"
        icon="zm-icon-close"
        class="zm-message__closeBtn"
        aria-label="Close this message"
        @click="close"
      />
    </div>
  </transition>
</template>

<script type="text/babel">
  import AriaDialog from '../../utils/aria-dialog';

  const typeMap = {
    success: 'success',
    info: 'Megaphone',
    warning: 'warning',
    error: 'error'
  };

  export default {
    data() {
      return {
        visible: false,
        message: '',
        duration: 4000,
        type: 'info',
        iconClass: '',
        customClass: '',
        onClose: null,
        showClose: false,
        closed: false,
        timer: null,
        verticalOffset: 0,
        dangerouslyUseHTMLString: false,
        center: false,
        useAriaDialog: false
      };
    },

    computed: {
      typeClass() {
        return this.type && !this.iconClass
          ? `zm-message__icon zm-icon-${ typeMap[this.type] }`
          : '';
      }
    },

    watch: {
      closed(newVal) {
        if (newVal) {
          this.visible = false;
          this.$el.addEventListener('transitionend', this.destroyElement);
        }
      },
      visible(newVal) {
        if (this.useAriaDialog && newVal) {
          this.focusAfterClosed = document.activeElement;
          this.$nextTick(()=>{
            this.ariaMessage = new AriaDialog(this.$el, this.focusAfterClosed);
          });
        }

      }
    },

    methods: {
      destroyElement() {
        this.$el.removeEventListener('transitionend', this.destroyElement);
        this.$destroy(true);
        this.$el.parentNode.removeChild(this.$el);
      },

      close() {
        this.closed = true;
        if (typeof this.onClose === 'function') {
          this.onClose(this);
        }
      },

      clearTimer() {
        clearTimeout(this.timer);
      },

      startTimer() {
        if (this.duration > 0) {
          this.timer = setTimeout(() => {
            if (!this.closed) {
              this.close();
            }
          }, this.duration);
        }
      },
      keydown(e) {
        if (e.keyCode === 27) { // esc关闭消息
          if (!this.closed) {
            this.close();
          }
        }
      }
    },
    mounted() {
      this.startTimer();
      document.addEventListener('keydown', this.keydown);
    },
    beforeDestroy() {
      document.removeEventListener('keydown', this.keydown);
      if (this.ariaMessage) {
        this.ariaMessage.closeDialog();
        this.ariaMessage = null;
      }
    }
  };
</script>

<style lang="scss">
@import "./style";
</style>
